import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import { headerBits } from "../../constants/tableConstants"

const CombinedBitRow = ({ 
  byteIndex, 
  bits,
  meaning, 
  onBitToggle,
}) => {
  
  const handleCellClick = (bit, currentValue) => {
    if (onBitToggle) {
      onBitToggle(bit, currentValue)
    }
  }
  
  const getActiveBit = (headerBit) => {
    return bits.find(bit => bit.bit === headerBit);
  }
  
  return (
    <tr>
      {headerBits.map(h => {
        const activeBit = getActiveBit(h);
        const isActive = activeBit?.value || false;
        const isClickable = !!activeBit;
        
        return (
          <td 
            key={`combined-${h}`} 
            className={classNames("text-center align-middle")}
            style={{
              cursor: isClickable && onBitToggle ? 'pointer' : 'default',
              opacity: isClickable ? 1 : 0.3,
              width: '32px',
              height: '30px',
              padding: '6px 4px',
              backgroundColor: isActive ? '#d6f3e9' : '#ffffff'
            }}
            onClick={isClickable && onBitToggle ? () => handleCellClick(h, isActive) : undefined}
            title={isClickable && onBitToggle ? "Click to toggle bit" : ""}
          >
            {isClickable ? (
              <span 
                style={{
                  fontSize: '0.95rem',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                className={classNames("text-muted", { 
                  "fw-bold": isActive,
                  "user-select-none": onBitToggle
                })}>
                {isActive ? "1" : "0"}
              </span>
            ) : ""}
          </td>
        )
      })}
      <td className={classNames("text-start align-middle")} 
          style={{
            fontSize: '0.95rem', 
            lineHeight: '1.4',
            padding: '10px 12px',
            wordWrap: 'break-word',
            backgroundColor: '#ffffff'
          }}>
         <span style={{fontWeight: '400'}}>
           {meaning}
         </span>
      </td>
    </tr>
  )
}

CombinedBitRow.propTypes = {
  byteIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  bits: PropTypes.arrayOf(PropTypes.shape({
    bit: PropTypes.number.isRequired,
    value: PropTypes.bool.isRequired,
  })).isRequired,
  meaning: PropTypes.string.isRequired,
  onBitToggle: PropTypes.func,
  title: PropTypes.string,
}

export default CombinedBitRow
